import { Component, Input, OnDestroy, OnInit, Type, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { TopbarService } from '../topbar.service';
import { AuthService } from '@kodit/core/services';
import { Sidebar } from 'primeng/sidebar';
import {
  DynamicDialogConfig,
  DynamicDialogService,
} from '@kodit/core/shared-ui';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { VerzijaSoftveraDijalogComponent } from '../../footer/verzija-softvera-dijalog/verzija-softvera-dijalog.component';
import { KreirajTiketFormComponent } from '../kreiraj-tiket-form/kreiraj-tiket-form.component';
import { KORISNICKA_PODRSKA_MOBILE } from '@kodit/core/shared';

@Component({
  selector: 'kodit-profil-sidebar',
  templateUrl: './profil-sidebar.component.html',
  styleUrls: ['./profil-sidebar.component.scss'],
})
export class ProfilSidebarComponent implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();
  showSidebar: boolean;
  clientPackageId: string;
  el: any;
  showcloseIcon = false;
  isInactive: boolean;
  @ViewChild('ProfilSidebar') sidebarRef: Sidebar;
  /** Configurations */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);

  /** I/O */
  @Input() isExpiredLayout: boolean;

  constructor(
    private service: TopbarService,
    private _authService: AuthService,
    private _dialogService: DynamicDialogService
  ) {
    this.isInactive = !this._authService.getIsTenantActive;
  }

  ngOnInit(): void {
    this._subs.add(
      this.service.getShowProfileSidebar.subscribe((show) => {
        this.showSidebar = show;
      })
    );
  }

  onHide() {
    this.service.hideProfileSidebar();
    this._destroy();
  }

  onShow() {
    this.service.hidePodesavanjaSidebar();
    this.service.hideNotifikacijeSidebar();
  }

  logOff() {
    this._authService.logout();
  }

  private _destroy() {
    if (this.sidebarRef) {
      this.service.hideProfileSidebar();
      this.sidebarRef.destroyModal();
    }
  }

  openDialog(formType: Type<KreirajTiketFormComponent>): void {
    this._dialogService.open(formType, this.dialogConfig);
  }

  openVerzijaSoftveraDijalog() {
    this.dialogConfig.hideSubmit = true;
    this.dialogConfig.customCancelButton = {
      icon: 'far fa-window-close',
      label: 'Zatvori',
    };
    this.dialogConfig.maximisable = false;
    this.dialogConfig.header = 'Informacije o softveru';
    this._dialogService.open(
      VerzijaSoftveraDijalogComponent,
      this.dialogConfig
    );
  }

  public openKreirajTiketDialog(type: string) {
    this.dialogConfig.header =
      type === 'pitanje' ? 'Postavite pitanje' : 'Prijavite problem';
    this.dialogConfig.data = { type };
    this.dialogConfig.customSubmitButton = {
      icon:
        type === 'pitanje'
          ? 'fa-solid fa-envelope'
          : 'fa-regular fa-triangle-exclamation',
      label: type === 'pitanje' ? 'Pošalji' : 'Prijavi',
    };
    this.openDialog(KreirajTiketFormComponent);
  }

  ngOnDestroy() {
    this._destroy();
    this.service.hideProfileSidebar();
    this._subs.unsubscribe();
  }

  public readonly KORISNICKA_PODRSKA_MOBILE = KORISNICKA_PODRSKA_MOBILE;
}
